<template>
    <div>
        <el-form   ref="lineForm" :model="editData" label-width="110px" size="mini">
            <el-form-item prop="name" class="lable-width" label="食堂名称" :rules="{required: true, message: '请输入食堂名称', trigger: 'blur'}">
                <el-input class="input-width" placeholder="请输入食堂名称" clearable v-model="editData.name" ></el-input>
            </el-form-item>
            <el-form-item prop="note" class="lable-width" :label="$t('form_notes')" >
                <el-input class="input-width" placeholder="请输入备注" clearable v-model="editData.note" ></el-input>
            </el-form-item>
            <el-form-item prop="createTime" class="lable-width" label="发布时间">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" disabled  clearable v-model="editData.createTime" ></el-input>
                </div>
            </el-form-item>
            <el-form-item prop="vc_lruname" class="lable-width" label="录入人姓名">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" disabled  clearable v-model="editData.vc_lruname"></el-input>
                </div>
            </el-form-item>
            <el-form-item  label="是否启用">
                <div style="margin-left: 34px">
                    <el-radio v-model="editData.state" :label="1">启用</el-radio>
                    <el-radio v-model="editData.state" :label="0">不启用</el-radio>
                </div>
            </el-form-item>
            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit" :disabled="isDisable">保存</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'addCanteen',
        props:{
            title:{
              type:String
            },
            editData1:{
                type:Object
            },
            i_lruid:{
                type:Number
            }
        },
        data(){
            return{
                dialogImageUrl: '',
                dialogVisible: false,
                isDisable:false,
                editData:this.editData1,
                value:'',
                validateCode:'',
                validateKeynames:'',
                mainTable:'',
                // i_lruid:'',
                deleteLi: "",
                deleteLidex:'',
                fileid1:'',

                // rules: {
                //     price: [
                //         {required: true, message: '请输入菜品价格', trigger: 'blur'},
                //         // {pattern: /^-?\d+(\.\d+)?$/, message: "请输入合法面积", trigger: "blur" },
                //         // {pattern: /^[0-9]*$/, message: "请输入数字", trigger: "blur" },
                //         {pattern: /^[0-9]+\.{0,1}[0-9]{0,15}$/, message: "请输入大于0的数字", trigger: "blur" },
                //         {pattern: /^\d+(\.\d{1,5})?$/, message: "请保留五位小数", trigger: "blur" }
                //     ]
                // }
            }
        },
        watch:{

        },
        mounted(){

            // if(this.title=='编辑食堂'){
            //
            //     this.getDetail()
            // }

        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),

            close(){
                this.$emit('close')
            },

            onSubmit(){
                    // this.$emit('editData', this.editData)
                this.save()
            },

            //食堂保存
            async save(val) {
                if(this.editData.name==''){
                    this.$message({
                        message: '请输入食堂名称',
                        type: 'error'
                    });
                    return
                }
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }

                let params = {
                    id:this.editData.id,
                    name:this.editData.name,
                    note:this.editData.note,
                    // i_lruid:parseInt(this.editData.i_lruid),
                    i_lruid:this.editData.i_lruid,
                    creator:this.i_lruid,
                    vc_lruname:this.editData.vc_lruname,
                    state:this.editData.state,
                    validateCode:this.editData.validateCode,
                    validateKeynames:this.editData.validateKeynames,
                    mainTable:this.editData.mainTable,
                    type:this.editData.type,
                    createTime:this.editData.createTime,
                }
                // console.log(parseInt(this.editData.i_lruid))
                // console.log(typeof this.editData.i_lruid)

                // return
                this.isDisable = true
                let res = await API.save(params);
                if (res.code == 1) {
                    this.isDisable = false
                    this.$emit("close")
                    this.$emit('getList')
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.isDisable = false
                    this.$message.error(res.message);
                }
            },

        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .upload-box img{
        width: 80px !important;
        height: 80px !important;
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    /*11111111111*/
    .mrr2{
        margin-right: 2px;
    }
    .img-box{
        /*border: 1px solid red;*/
        .uploadPhone{
            width: 70px;
            height: 80px;
            position: relative;
            width: 100px;
            padding-left: 50px;
            /*border: 1px solid cornflowerblue;*/
        }
        .uploadPhone .img{
            width: 80px;
            height: 80px;
            margin-right: 5px;
        }
        .elimg{
            width:105px
        }
        .el-icon-delete{
            padding-right: 5px;
        }

        /*.uploadPhone video{*/
        /*    width: 100px;*/
        /*    height: 80px;*/
        /*}*/

        .upload-box{
            /*background: red;*/
            width: 100%;
            height: 100%;
        }
        .upload-input{
            position: absolute;
            opacity: 0;
            width: 80px;
            height: 80px;
        }
    }
    .flex{
        display: flex;
    }
    .flex1{
        display: flex;
    }
    /*1111111111*/
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
</style>